import { gql } from '@apollo/client';
import config from '../../config';

const indexName = config.algolia.algolia_prefix + 'items_query_suggestions';
const typeName = config.algolia.algolia_prefix + 'items_query_suggestions';

export const ITEM_SUGGESTION = gql`
query LocationsQuery ($query : String!, $filters: String!, $facets: [String]!) {
  locationsInRadius @algolia(
      __typename: ${typeName}, 
      index: ${indexName}, 
      filters: $filters, 
      hitsPerPage: 20, 
      query: $query,
      facets: $facets
  ) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;
